import Text from '~/components/UI/Text'

export default Text